import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

export const ScrollFirstError: React.FC = () => {
  const { isValid, errors, submitCount } = useFormikContext();

  useEffect(() => {
    if (isValid) {
      return;
    }

    const fieldErrorNames = Object.keys(errors);
    if (fieldErrorNames.length <= 0) {
      return;
    }

    const input: HTMLInputElement | null = document.querySelector(`input[name='${fieldErrorNames[0]}']`);
    if (!input) {
      return;
    }

    const label = input?.parentElement?.previousSibling as HTMLLabelElement;
    const scrollToLabel = () => {
      if (input === document.activeElement) {
        label.scrollIntoView({ behavior: 'smooth' });
      }
    };

    if (label) {
      label.addEventListener('transitionend', scrollToLabel, { once: true });
    }

    if (!label) {
      input.scrollIntoView({ behavior: 'smooth' });
    }

    input.focus({ preventScroll: true });
  }, [submitCount]);

  return null;
};
